<script lang="ts">
	import { Database, PanelsTopLeft, User } from 'lucide-svelte';

	import { page } from '$app/state';

	import * as Sidebar from '$lib/components/ui/sidebar';

	import { cn } from '$lib/utils';

	const items = [
		{
			title: 'Profile',
			icon: User,
			url: '/settings/profile'
		},
		{
			title: 'Appearance',
			icon: PanelsTopLeft,
			url: '/settings/appearance'
		},
		{
			title: 'Data',
			icon: Database,
			url: '/settings/data'
		}
	];
</script>

<Sidebar.Menu>
	{#each items as item (item)}
		{@const isActive = page.url.pathname.startsWith(item.url)}

		<Sidebar.MenuItem>
			<Sidebar.MenuButton
				{isActive}
				class={cn(
					'transition-all',
					isActive && 'border-l-2 ml-2 pl-2 border-muted bg-transparent! font-semibold! shadow-xs'
				)}
			>
				{#snippet child({ props })}
					<a href={item.url} {...props}>
						{#if item.icon}
							<item.icon class="size-4" />
						{/if}

						<span>{item.title}</span>
					</a>
				{/snippet}
			</Sidebar.MenuButton>
		</Sidebar.MenuItem>
	{/each}
</Sidebar.Menu>
